var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"title":"编辑购买信息","left-arrow":""}},[_c('CarOwnerModel',{ref:"carOwnerModel",attrs:{"info":_vm.orderInfo}}),_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{on:{"click":function($event){return _vm.$page.close()}}},[_vm._v("取消")]),_c('Button',{on:{"click":_vm.onSave}},[_vm._v("确认")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }